import React from "react"
import styles from "./backgroundSelectFilter.module.css"
import { MdOutlineFilterAlt } from "react-icons/md"

const BackgroundSelectFilter = ({ title = "Defina os filtros", text }) => {
    return (
        <div className={styles.container}>
            <div className={styles.icon}>
                <MdOutlineFilterAlt />
            </div>
            <div className={styles.copy}>
                <strong>{title}</strong>
                <span>{text}</span>
            </div>
        </div>
    )
}

export default BackgroundSelectFilter
